import {Component} from '@angular/core';
import {FieldWrapper} from '@ngx-formly/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'formly-wrapper-primeng-form-field',
    template: `
        <label class="mb-2" *ngIf="to.label && to.hideLabel !== true" [for]="id">
            {{ to.label }}
            <span *ngIf="to.required && to.hideRequiredMarker !== true" aria-hidden="true">*</span>
        </label>
        <ng-container #fieldComponent></ng-container>
        <small *ngIf="showError" class="p-error">
            <formly-validation-message class="ui-message-text" [field]="field"></formly-validation-message>
        </small>
    `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyCenterWrapper extends FieldWrapper {
}
